import { mock } from 'universal-mock';
import { Clevertap } from 'mf-config/types';

import getBusinessId from '../../selectors/getBusinessId';
// @ts-ignore
import serviceWorkerPath from '../serviceWorker/sw';
import store from '../store';
import { getUnleashInstance } from '../unleash';

/**
 * @description We are using service work for Clevertap Web Push
 *              When testing locally, you need HTTPS.
 *              See https://mokapos.atlassian.net/wiki/spaces/MT/pages/23429121/Developing+with+HTTPS
 */
async function setupClevertap() {
  if (!process.env.CLEVERTAP_ID) return;

  const state = store.getState();
  const businessId = getBusinessId(state);
  const unleash = await getUnleashInstance(businessId);
  const isEnabled = unleash.isEnabled('clevertap-gtm-migration');

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(serviceWorkerPath);
  }

  if (isEnabled) {
    if (window.initClevertap) {
      // Run the init script from GTM
      window.initClevertap(process.env.CLEVERTAP_ID);
    } else {
      // Init script / GTM isn't ready yet, provide the getClevertapId so that
      // the GTM can run it later
      window.getClevertapId = function () {
        return process.env.CLEVERTAP_ID;
      };
    }
  } else {
    const clevertap: Clevertap = {
      event: [],
      profile: [],
      account: [],
      onUserLogin: [],
      notifications: [],
      privacy: [],
    };

    window.clevertap = clevertap;

    clevertap.account.push({ id: process.env.CLEVERTAP_ID });
    clevertap.privacy.push({ optOut: false });
    clevertap.privacy.push({ useIP: false });

    (function setup() {
      const wzrk = document.createElement('script');
      wzrk.type = 'text/javascript';
      wzrk.async = true;
      wzrk.src =
        document.location.protocol === 'https:'
          ? 'https://d2r1yp2w7bby2u.cloudfront.net/js/a.js'
          : 'https://static.clevertap.com/js/a.js';
      const s = document.getElementsByTagName('script')[0];
      s.parentNode?.insertBefore(wzrk, s);
    })();
  }
}

function setupTrackers() {
  window.clevertap = window.clevertap ?? mock;
  setupClevertap();
}

export { setupTrackers };
